import { jwtDecode } from "jwt-decode";
import Logger from "../../Logger";
import { getExcelSheetNamesResult, uploadFileResult } from "../../api/flatfile";

export const getMaxFileSizeLimit = (token: string): number => {
  const decodedToken: any = jwtDecode(token);
  const access = decodedToken.access;
  return access === "community" ? 50 : 100; // in MB
};

export const validateFileSelection = (
  file: File | undefined,
  selectedFileType: string | undefined,
  maxFileSizeMB: number
): { isValid: boolean; errorMessage?: string } => {
  if (!file) {
    return { isValid: false };
  }

  const fileExtension = file.name.split(".").pop()?.toLowerCase();
  const isValidFileType = 
    (selectedFileType === "csv" && fileExtension === "csv") ||
    (selectedFileType === "json" && fileExtension === "json") ||
    (selectedFileType === "excel" && fileExtension === "xlsx");
  
  if (!isValidFileType) {
    return { 
      isValid: false, 
      errorMessage: `Invalid file type. Expected ${selectedFileType === "excel" ? "an .xlsx" : `a .${selectedFileType}`} file.`
    };
  }

  const maxFileSize = maxFileSizeMB * 1024 * 1024;
  if (file.size > maxFileSize) {
    return { 
      isValid: false, 
      errorMessage: `File size exceeds the maximum limit of ${maxFileSizeMB} MB.`
    };
  }

  return { isValid: true };
};

export const validateJsonContent = (content: string): { isValid: boolean; errorMessage?: string } => {
  try {
    JSON.parse(content);
    const jsonObject = JSON.parse(content);
    console.log(jsonObject);
    return { isValid: true };
  } catch {
    return { 
      isValid: false, 
      errorMessage: "JSON Object is not in the expected format"
    };
  }
};

export const getExcelSheetNames = async (
  formData: FormData,
  token: string
): Promise<{ 
  success: boolean; 
  sheetNames?: string[]; 
  fileId?: string; 
  fileName?: string;
  errorMessage?: string;
}> => {
  try {

    const res = await getExcelSheetNamesResult(formData);
    
    if (!res.isError && res.data) {
      return {
        success: true,
        sheetNames: res.data.sheetNames,
        fileId: res.data.fileId,
        fileName: res.data.fileName
      };
    } else {
      return {
        success: false,
        errorMessage: res.message ?? "Failed to retrieve sheet names"
      };
    }
  } catch (error) {
    Logger("error", "Failed to retrieve Excel sheet names", error);
    return {
      success: false,
      errorMessage: "An unexpected error occurred"
    };
  }
};

export const uploadFile = async (
  formData: FormData,
  fileType: string,
  token: string
): Promise<{
  success: boolean;
  data?: any;
  errorMessage?: string;
}> => {
  try {

    const result =  await uploadFileResult(formData, fileType);

    if (!result.isError && result.data) {
      return {
        success: true,
        data: result.data
      };
    } else {
      Logger("info", "File upload error");
      return {
        success: false,
        errorMessage: result.message,
      };
    }
  } catch (error) {
    Logger("error", "File upload exception", error);
    return {
      success: false,
      errorMessage: "An unexpected error occurred during upload"
    };
  }
};